var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(-877 -425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(897 445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M12-15.52A27.52,27.52,0,1,1-15.52,12,27.519,27.519,0,0,1,12-15.52ZM12-20A32,32,0,1,0,44,12,32,32,0,0,0,12-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M5.2,1.809h0C4.735.6,4.274-.585,3.841-1.786A.594.594,0,0,1,4.1-2.3a26.627,26.627,0,0,1,3.616-1.28,14.14,14.14,0,0,1,7.232.115A6.875,6.875,0,0,1,20.1,3.155a7.742,7.742,0,0,1-1.965,5.76c-.435.512-.9,1.005-1.363,1.491a9.03,9.03,0,0,0-2.778,6.6v.339H7.975a10.008,10.008,0,0,1,.48-4.32,13.9,13.9,0,0,1,2.733-4.684,10.393,10.393,0,0,0,1.779-2.637c.871-1.978-.237-3.68-2.4-3.885A8.337,8.337,0,0,0,5.6,2.842C5.468,2.5,5.334,2.152,5.2,1.809Z",
    fill: "#f45000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M6.777,23.8A4.224,4.224,0,0,0,10.969,28a4.179,4.179,0,1,0-.039-8.358,2.441,2.441,0,0,0-.32,0A4,4,0,0,0,6.777,23.8Z",
    fill: "#f45000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.ce2bca86ae5434a9616bdf53e798c134.svg";
export { ForwardRef as ReactComponent };